import {Injectable, signal} from '@angular/core';
import {UnitEconomicsCalculationsFile} from "../types/unit-economics-calculations-file.types";

@Injectable({
  providedIn: 'root'
})
export class UnitEconomicsCalculationsFilesStateService {
  private _unitEconomicsCalculationsFilesState = signal<Record<number, Array<UnitEconomicsCalculationsFile>>>({});
  public unitEconomicsCalculationsFilesState = this._unitEconomicsCalculationsFilesState.asReadonly();

  public setUnitEconomicsCalculationsFilesState(id: number, unitEconomicsCalculationsFiles: Array<UnitEconomicsCalculationsFile>): void {
    this._unitEconomicsCalculationsFilesState.set({
      ...this._unitEconomicsCalculationsFilesState(),
      [id]: unitEconomicsCalculationsFiles
    });
  }

  public getUnitEconomicsCalculationsFilesById(id: number): Array<UnitEconomicsCalculationsFile> {
    return this.unitEconomicsCalculationsFilesState()[id];
  }

  public deleteFileById(fileId: number, unitEconomicsCalculationsId: number): void {
    this._unitEconomicsCalculationsFilesState.update(state => {
      const currentFiles = state[unitEconomicsCalculationsId] || [];
      const updatedFiles = currentFiles.filter(file => file.id !== fileId);

      return {
        ...state,
        [unitEconomicsCalculationsId]: updatedFiles
      };
    });
  }

  public updateUnitEconomicsCalculationsFilesState(unitEconomicsCalculationsId: number, unitEconomicsCalculationsFile: UnitEconomicsCalculationsFile): void {
    this._unitEconomicsCalculationsFilesState.update(state => {
      const currentFiles = state[unitEconomicsCalculationsId] || [];
      const updatedFiles = [ ...currentFiles, unitEconomicsCalculationsFile ];

      return {
        ...state,
        [unitEconomicsCalculationsId]: updatedFiles
      };
    });
  }

  public deleteUnitEconomicsCalculationsFilesState(unitEconomicsCalculationsId: number): void {
    this._unitEconomicsCalculationsFilesState.update(state => {
      const newState = { ...state };
      delete newState[unitEconomicsCalculationsId];
      return newState;
    });
  }
}
